import { BASE_URL } from "../../data/BaseUrl";

export const fetchIncentivesStats = async (filters, TOKEN) => {
  let url = `incentive/stats`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchIncentivesStats=> ", error);
    throw error;
  }
};

export const fetchIncentivesSlabs = async (filters, TOKEN) => {
  let url = `incentive/slabs`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    const slabs = {
      data: responseJson.data || [],
      pagination: responseJson.pagination || [],
      dropdown: responseJson?.data?.map((slab) => ({
        value: slab.uid,
        label: `₹${slab.min_amount || 0}-₹${slab.max_amount || 0}(${
          slab.percentage || 0
        }%)`,
        info: slab,
      })),
    };

    return slabs;
  } catch (error) {
    console.error("fetchIncentivesSlabs=> ", error);
    throw error;
  }
};

export const fetchTrainerIncentives = async (filters, TOKEN) => {
  let url = `incentive`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchTrainerIncentives=> ", error);
    throw error;
  }
};

export const fetchTrainerNotificationLogs = async (filters, TOKEN) => {
  let url = `trainer/trainerNotificationLogs`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchTrainerNotificationLogs=> ", error);
    throw error;
  }
};

export const fetchFDIncentives = async (filters, TOKEN) => {
  let url = `incentive/fd/slab`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchFDIncentives=> ", error);
    throw error;
  }
};
